




































import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  AcoesLeadService,
  AcaoLead,
  Filtro,
} from "@/services/acoes-lead.service";
import Loading from "@/shared/components/loading.vue";
import DataTable from "@/shared/components/data-table.vue";
import { Paginacao } from "@/shared/interface";
import { ServerPageOptions } from "@/shared/utils/datatable";
import { dateTime, dateTimeSeconds } from "@/shared/filters";
import AdicionarAcaoLead from "../modals/AdicionarAcaoLead.vue";

@Component({
  components: { Loading, DataTable, AdicionarAcaoLead },
  filters: { dateTimeSeconds, dateTime },
})
export default class AcoesLead extends Mixins(GlobalMixin) {
  @Prop() readonly idLead!: number;
  loading = false;
  promise: Promise<Paginacao<AcaoLead>> | null = null;

  filtro: Filtro = {
    offset: 0,
    limit: 100,
    order: "",
  };

  headers = [
    { value: "dataCadastro", text: "Data" },
    { value: "observacao", text: "Observação" },
    { value: "usuario.nome", text: "Responsável" },
  ];

  fetchAcoesLeads(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }
    this.promise = AcoesLeadService.ListarAcoesLead(this.idLead, this.filtro);
  }

  async adicionarAcaoLead() {
    const modal = this.$refs.adicionarAcaoLead as AdicionarAcaoLead;
    if (this.idLead) {
      await modal.adicionarAcaoLead(this.idLead);
    }
    this.fetchAcoesLeads();
  }
}
